import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space6 } = theme();

  return StyleSheet.create({
    helpLink: {
      marginBottom: space6,
    },
    instructionsTitle: {
      marginBottom: space6,
    },
    returnInstructions: {
      marginBottom: space6,
    },
  });
};

export { style };
